var render, staticRenderFns
import script from "./render-html.vue?vue&type=script&lang=js&"
export * from "./render-html.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35bf3c6d')) {
      api.createRecord('35bf3c6d', component.options)
    } else {
      api.reload('35bf3c6d', component.options)
    }
    
  }
}
component.options.__file = "frontend/static/js/components/render-html.vue"
export default component.exports